import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/index'
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/index',
                    component: () => import(/* webpackChunkName: "index" */ '../components/page/Index.vue'),
                    meta: { title: '控制台' }
                },
                {
                    path: '/menumanage',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/menu/Menumanage.vue'),
                    meta: { title: '菜单管理' }
                },
                {
                    path: '/rolemanage',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/role/Rolemanage.vue'),
                    meta: { title: '角色管理' }
                },
                {
                    path: '/accountmanage',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/account/Accountmanage.vue'),
                    meta: { title: '账号管理' }
                },
                {
                    path: '/icon',
                    component: () => import(/* webpackChunkName: "icon" */ '../components/page/Icon.vue'),
                    meta: { title: '自定义图标' }
                },
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                }
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '/outlogin',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Outlogin.vue'),
            meta: { title: '子系统退出登录' }
        },
        {
            path: '/check',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Check.vue'),
            meta: { title: 'token定向' }
        },
        {
            path: '*',
            redirect: '/404'
        },
        {
            path: '/datamap',
            component: () => import(/* webpackChunkName: "403" */ '../components/page/datamap.vue'),
            meta: { title: '403' }
        }
    ]
});

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
